/*
 * @file: dashboard.js
 * @description: Reducers and actions
 * @author: navreet
 */

import * as TYPE from '../../actions/constants'

/******** Reducers ********/
const initialState = {
    data: null,
    redeemGraph: [],
    userGraph: [],
    emissionGrpah: [],
    pieChart: [],
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TYPE.DASHBOARD:
            return { ...state, data: action.data }
        case TYPE.REDEEMGRAPH:
            return { ...state, redeemGraph: action.data }
        case TYPE.USERGRAPH:
            return { ...state, userGraph: action.data }
        case TYPE.EMISSIONGRAPH:
            return { ...state, emissionGrpah: action.data }
        case TYPE.PIECHART:
            return { ...state, pieChart: action.data }
        case TYPE.LOG_OUT:
            return { ...initialState }
        default:
            return state
    }
}
